var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { SAIcon, SAIcons } from '../icon';
var AvatarSizes;
(function (AvatarSizes) {
    AvatarSizes["xxs"] = "30px";
    AvatarSizes["xs"] = "45px";
    AvatarSizes["small"] = "60px";
    AvatarSizes["medium"] = "90px";
    AvatarSizes["large"] = "120px";
    AvatarSizes["xl"] = "150px";
    AvatarSizes["xxl"] = "180px";
})(AvatarSizes || (AvatarSizes = {}));
// Avatar Styles
var Avatar = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (_a) {
    var size = _a.size;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      width: ", ";\n      height: ", ";\n      background-color: #3e5572;\n      border: 2px solid #fff;\n      position: relative;\n      border-radius: 50%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    "], ["\n      width: ", ";\n      height: ", ";\n      background-color: #3e5572;\n      border: 2px solid #fff;\n      position: relative;\n      border-radius: 50%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    "])), AvatarSizes[size], AvatarSizes[size]);
});
// Subcomponents
var Initials = function (_a) {
    var initials = _a.initials, id = _a.id;
    return (React.createElement("svg", { width: "43%", height: "43%", viewBox: "0 0 100 100", preserveAspectRatio: "xMinYMid meet", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", "aria-labelledby": id },
        React.createElement("title", { id: id }, initials.toUpperCase()),
        React.createElement("text", { x: "50", y: "50", fontSize: "80", fontWeight: "bold", fill: "white", dominantBaseline: "middle", textAnchor: "middle" }, initials.toUpperCase())));
};
// Bottom Left Components
var Badge = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (_a) {
    var theme = _a.theme, badgeColor = _a.badgeColor;
    return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      background-color: ", ";\n      width: 40%;\n      height: 40%;\n      position: absolute;\n      bottom: 0;\n      left: -5%;\n      border-radius: 50%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      box-shadow: ", ";\n      svg {\n        width: 66%;\n      }\n    "], ["\n      background-color: ", ";\n      width: 40%;\n      height: 40%;\n      position: absolute;\n      bottom: 0;\n      left: -5%;\n      border-radius: 50%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      box-shadow: ", ";\n      svg {\n        width: 66%;\n      }\n    "])), theme.colors[badgeColor], theme.shadow.elevation.level1);
});
var CustomBottomLeft = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  position: absolute;\n  bottom: 0;\n  left: 0;\n"], ["\n  position: absolute;\n  bottom: 0;\n  left: 0;\n"])));
export var BottomLeftComponent = function (_a) {
    var badge = _a.badge, bottomLeft = _a.bottomLeft, badgeColor = _a.badgeColor;
    if (badge && badgeColor) {
        return (React.createElement(Badge, { badgeColor: badgeColor, className: "sa-avatar-badge" },
            React.createElement(SAIcon, { icon: SAIcons[badge], colorVariant: "light" })));
    }
    if (bottomLeft) {
        return React.createElement(CustomBottomLeft, null, bottomLeft);
    }
    return null;
};
// Top Right Components
var StyledNotificationIcon = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (_a) {
    var theme = _a.theme;
    return css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      background-color: ", ";\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: 30%;\n      height: 30%;\n      border-radius: 50%;\n      position: absolute;\n      top: 0;\n      right: 0;\n    "], ["\n      background-color: ", ";\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: 30%;\n      height: 30%;\n      border-radius: 50%;\n      position: absolute;\n      top: 0;\n      right: 0;\n    "])), theme === null || theme === void 0 ? void 0 : theme.colors.red500);
});
var NotificationIcon = function (_a) {
    var notifications = _a.notifications, id = _a.id;
    var getTitle = function (count) {
        if (typeof notifications === 'number') {
            if (notifications === 1) {
                return count + " notification";
            }
            return count + " notifications";
        }
        return "notifications";
    };
    return (React.createElement(StyledNotificationIcon, { className: "sa-avatar-notification-icon" }, notifications && (React.createElement("svg", { width: "90%", height: "90%", viewBox: "0 0 100 100", preserveAspectRatio: "xMinYMid meet", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", "aria-labelledby": id },
        React.createElement("title", { id: id }, getTitle(notifications)),
        React.createElement("text", { x: "50", y: "55", fontSize: "80", fontWeight: "bold", fill: "white", dominantBaseline: "middle", textAnchor: "middle" }, notifications)))));
};
var CustomTopRight = styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  right: 0;\n"], ["\n  position: absolute;\n  top: 0;\n  right: 0;\n"])));
export var TopRightComponent = function (_a) {
    var notifications = _a.notifications, topRight = _a.topRight, id = _a.id;
    if (notifications) {
        return React.createElement(NotificationIcon, { id: id, notifications: notifications });
    }
    if (topRight) {
        return React.createElement(CustomTopRight, { className: "sa-avatar-custom-top-right" }, topRight);
    }
    return null;
};
// Main Component
export var SAAvatar = function (_a) {
    var id = _a.id, className = _a.className, initials = _a.initials, bottomLeft = _a.bottomLeft, topRight = _a.topRight, notifications = _a.notifications, badge = _a.badge, badgeColor = _a.badgeColor, size = _a.size, rest = __rest(_a, ["id", "className", "initials", "bottomLeft", "topRight", "notifications", "badge", "badgeColor", "size"]);
    return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(Avatar, __assign({ size: size, id: id, className: "sa-avatar-wrapper" + (className ? " " + className : '') }, rest),
        React.createElement(Initials, { id: id + "-initials", initials: initials }),
        bottomLeft || badge ? React.createElement(BottomLeftComponent, { badge: badge, badgeColor: badgeColor, bottomLeft: bottomLeft }) : '',
        (topRight || notifications) && (React.createElement(TopRightComponent, { id: id + "-notification", notifications: notifications, topRight: topRight }))));
};
SAAvatar.defaultProps = {
    badgeColor: 'green500',
    size: 'small',
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
//# sourceMappingURL=avatar.component.js.map